import React from 'react';
import { StatusInfoWarning } from './StatusInfoWarning';

/**
 * Styled Component for ReactGuard / ErrorBoundary
 * */
export function StatusInfoErrorBoundary() {
  return <StatusInfoWarning modifier={['center', 'padding']} />;
}
